import { fbt } from 'fbtee'
import { useCoarsePointer } from '../../../hooks/useCoarsePointer'

export function TrimConflictTipBody({ clashesWith }: { clashesWith: string }) {
  const coarse = useCoarsePointer()
  return (
    <span className="flex flex-col gap-0.5">
      <span>
        {fbt(
          'Clashes with ' + fbt.param('name', clashesWith),
          'First line of the schedule coachmark on a Going set that overlaps another Going set; the param is the other set’s artist name',
        )}
      </span>
      <span className="text-muted-foreground">
        {coarse
          ? fbt(
              'Long-press to pick the part you’ll catch',
              'Second line of the clash coachmark on touch devices: long-pressing the set card lets you trim it to part of the set',
            )
          : fbt(
              'Click and hold to pick the part you’ll catch',
              'Second line of the clash coachmark on desktop: click-and-holding the set card lets you trim it to part of the set',
            )}
      </span>
    </span>
  )
}
